import { type QueryClient, type QueryKey } from '@tanstack/react-query';

import { LIBRARY_BOARDS_LIST } from '~/components/LibraryBeta/hooks/queries/useLibraryRootBoards';
import { isPrivateBoardsListKey, PRIVATE_BOARDS_LIST_KEY } from '~/components/v2/hooks/queries/usePrivateBoardsList';
import { FAVORITE_BOARDS } from '~/swr-hooks/boards/useFavoriteBoardsList';
import { PRIVATE_GENERAL_LIBRARY_BOARDS_LIST_KEY } from '~/swr-hooks/boards/usePrivateGeneralLibraryBoardsList';
import { BOARD_SUBBOARDS } from '~/swr-hooks/boards/useSubBoardsList';
import { BOARDS_LIST } from '~/swr-hooks/boards/useWorkspaceBoards';

/** React Query `queryKey[0]` values for workspace board trees (rail, favorites, mention picker, ItemPicker). */
export const WORKSPACE_AGENT_BOARD_NAVIGATION_QUERY_MAIN_KEYS = new Set<string>([
  BOARDS_LIST,
  LIBRARY_BOARDS_LIST,
  BOARD_SUBBOARDS,
  PRIVATE_BOARDS_LIST_KEY,
  FAVORITE_BOARDS,
  PRIVATE_GENERAL_LIBRARY_BOARDS_LIST_KEY,
]);

export const isWorkspaceAgentBoardNavigationQueryKey = (queryKey: QueryKey): boolean => {
  if (isPrivateBoardsListKey(queryKey)) {
    return true;
  }

  const mainKey = queryKey[0];

  return typeof mainKey === 'string' && WORKSPACE_AGENT_BOARD_NAVIGATION_QUERY_MAIN_KEYS.has(mainKey);
};

export type InvalidateWorkspaceAgentBoardNavigationQueriesParams = {
  queryClient: QueryClient;
};

/** Invalidates every cached workspace board-navigation list (rail, favorites, picker, mention tree). */
export const invalidateWorkspaceAgentBoardNavigationQueries = ({
  queryClient,
}: InvalidateWorkspaceAgentBoardNavigationQueriesParams): void => {
  void queryClient.invalidateQueries({
    predicate: ({ queryKey }) => isWorkspaceAgentBoardNavigationQueryKey(queryKey),
  });
};
